import { BsEmojiFrown } from "react-icons/bs";
import { BsEmojiSmile } from "react-icons/bs";

interface StatusProps {
    status: number;

}
export const StatusBadge = (props: StatusProps) => {
    return (
        <span className={` ${props.status === 1 ? "bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-400 border border-green-400" : "bg-red-100 text-red-800 dark:bg-red-700 dark:text-red-400 border border-red-400"} text-[11px] font-medium inline-flex items-center gap-1 px-2.5 py-0.5 rounded`}>
            {props.status === 1 ? <BsEmojiSmile /> : <BsEmojiFrown />}
            {props.status === 1 ? "Yes" : "No"}
        </span>
    )
}

